"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = void 0;
const specific_entity_1 = require("../../../abstracts/specific-entity");
/**
 * A specific `TenantUser` client for a particular tenant user id.
 * Use this client to query or mutate data for this particular user
 */
class User extends specific_entity_1.SpecificEntity {
    //TODO swap params order
    constructor(parentEntity, id, debug = false) {
        super(id, parentEntity, debug);
    }
    /**
     * Gets the user model for this user
     * @returns
     */
    async get() {
        return (await this.getHttpClient().get(`/tenant/user/${this.id}`, { headers: this.getHeaders() })).data;
    }
    /**
     * Update the user. You can change role, teams and also enable or disable the user from logging in.
     * @param args `UpdateUserRequestDto`
     * @returns `TenantUserResponseDto`
     */
    async update(args) {
        return (await this.getHttpClient().put(`/tenant/user/${this.id}`, args, { headers: this.getHeaders() })).data;
    }
    /**
     * Delete the user. This will prevent the user from loggin in.
     */
    async delete() {
        await this.getHttpClient().delete(`/tenant/user/${this.id}`, { headers: this.getHeaders() });
    }
    /**
     * Lists this users all associated users for other tenants
     */
    async listAssociations() {
        const result = await this.getHttpClient().get(`/tenant/user/${this.id}/associations`, { headers: this.getHeaders() });
        return result.data;
    }
    /**
     * Send the user an email
     * @param args `EmailUserRequestDto`
     */
    async sendEmail(args) {
        await this.getHttpClient().post(`/tenant/user/${this.id}/email`, args, { headers: this.getHeaders() });
    }
    /**
     * Initiates the reset password process for this user. Will send an email to user with a link to set a new password. The link will be constructed using {appUrl}/auth/set-password/XXXX.
     *
     * Similar to `Auth.forgotPassword()`.
     */
    async resetPassword() {
        await this.getHttpClient().post(`/tenant/user/${this.id}/password`, {}, { headers: this.getHeaders() });
    }
    /**
     * Get the reset password link, constructed using {appUrl}/auth/set-password/XXXX, *without* sending the an email.
     *
     * @returns `string` a password rest link
     */
    async getResetPasswordLink() {
        const result = await this.getHttpClient().get(`/tenant/user/${this.id}/passwordLink`, { headers: this.getHeaders() });
        return result.data;
    }
    /**
     * Send the user a SMS
     * @param args `SmsUserRequestDto`
     */
    async sendSms(args) {
        await this.getHttpClient().post(`/tenant/user/${this.id}/sms`, args, { headers: this.getHeaders() });
    }
    /**
     * Send an SMS to the user containing an OTP (One Time Password).
     * @returns `SendOtpSmsResponseDto` containing the generated OTP
     */
    async sendOtpSms() {
        return (await this.getHttpClient().post(`/tenant/user/${this.id}/smsOtp`, {}, { headers: this.getHeaders() })).data;
    }
}
exports.User = User;
